import React from 'react'
import "./Hero.css"


const Hero = () => {
    return (
        <>
           

            <div className="hero">

      <div className="herosection">
      

                <span>
                Best Self-Defence<br />
                    traning Class  
                </span>  
                <p>
                    Lorem ipsum dolor sit amet 
                    consectetur adipisicing elit.
                     Corporis accusamus <br /> assumenda dolore 
                     ab laudantium 
                     aperiam nesciunt facilis iste.
                    
                </p>
                <button className='herobtn'>
                        Book a Class
                    </button>
                </div>
                <div className="herostoke">
                    <span> your Fitness</span>
                   
                </div>
      </div>
      
        </>
    )
}

export default Hero